export function ClassGrouper(classes) {

   this.classMap = new Object();
   this.rangeStart = 0;
   this.rangeEnd   = 0;

   this.init = function(classes) {
     for (let cl of classes) {
      var year = cl.year;
      var ext   = cl.ext;
      var id    = cl.id;
      if (year in this.classMap === false) this.classMap[year] = Array();
      this.classMap[year].push({'id': id, 'ext': ext});
   }


      for (var year in this.classMap) {
         this.classMap[year].sort(function(a,b) {
            if (a.ext === b.ext) return 0;
            return a.ext < b.ext ? -1 : 1;
         });
      }

   };

   this.appendRange = function(ret) {

      if (ret === undefined) return;

      if (this.rangeStart != 0) {
         if (this.rangeEnd == 0) ret.push(this.rangeStart.toString());
         else                    ret.push(this.rangeStart + '-' + this.rangeEnd);
      }
      this.rangeStart = this.rangeEnd = 0;

   };

   this.group = function(classes) {

      if (typeof(classes) !== 'object') return '';

      var years = Array();
      this.rangeStart = 0;
      this.rangeEnd   = 0;

      for (var i in this.classMap) {

         if (i > 13) continue;

         var has = this.hasYear(i, classes);

         if (has != false) {
            if (typeof(has) == 'number') {
               if (this.rangeStart == 0) this.rangeStart = has;
               else                      this.rangeEnd   = has;
            }
            else {
               this.appendRange(years);
               years.push(has);
            }
         }
         else {
            this.appendRange(years);
         }

      }

      this.appendRange(years);

      return years;

   };


   /* Rückgabewerte:
   *  Wenn der Jahrgang gar nicht vorhanden ist: false
   *  Wenn der Jahrgang komplett  vorhanden ist: das Jahr (als Zahl)
   *  Wenn der Jahrgang teilweise vorganden ist: das Jahr mit den entsprechenden Extensions
   */
   this.hasYear = function(year, classes) {

      var ext = '';
      var all = true;
      var has = false;

      for (let cls of this.classMap[year]) {
         if (cls.id in classes) {
            ext += cls.ext;
            has = true;
         }
         else {
            all = false;
         }
      }

      if (has === false) return false;
      if (all === true)  return parseInt(year, 10);
      return year + ext;

   };

   this.init(classes);

}
